import { SnackbarKey, useSnackbar } from 'notistack';
import { IconButton, IconButtonProps } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactElement } from 'react';

type InternalProps = {
  snackbarKey?: SnackbarKey;
  iconColor?: string;
};

export type CloseSnackbarButtonProps = IconButtonProps & InternalProps;

export default function CloseSnackbarButton(props: CloseSnackbarButtonProps): ReactElement {
  const { closeSnackbar } = useSnackbar();
  const { snackbarKey, iconColor, ...iconButtonProps } = props;

  return (
    <IconButton {...iconButtonProps} onClick={() => closeSnackbar(snackbarKey)} data-testid="closeSnackbarId">
      <CloseIcon sx={{ color: iconColor ?? 'white' }} />
    </IconButton>
  );
}
